import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import css from './TabGroupedErrors.css';

const TabGroupedErrors = ({ tabs, getTabErrors }) => (
    <div className={css.submitErrorList}>
        {tabs
            ?.map(tab => {
                const errors = getTabErrors(tab);
                if (!errors.length) return null;
                return (
                    <div key={tab.id}>
                        <div className={css.submitErrorTabTitle}>
                            <Translate id={tab.label} />
                        </div>
                        <ul>
                            {errors.map(({ key, messageKey }) => (
                                <li key={key}>
                                    <Translate id={messageKey} />
                                </li>
                            ))}
                        </ul>
                    </div>
                );
            })
            .filter(Boolean)}
    </div>
);

TabGroupedErrors.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })
    ),
    getTabErrors: PropTypes.func.isRequired,
};

export default TabGroupedErrors;
